/**
     * @desc 3分页查询我的盲盒列表,用户盲盒(isSystem=0)上下架要先调用合约
用于：个人盲盒列表页
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/box/selectMyBox', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/box/selectMyBox', params);
}
